import { render, staticRenderFns } from "./config.vue?vue&type=template&id=807cfe48&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=807cfe48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807cfe48",
  null
  
)

export default component.exports